import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { ActivityInterface } from '@vendasta/crm';
import { CrmActivityRecordChangeBaseComponent } from './record-change-base.component';
import { CrmActivityRecordChangeSalespersonUpdatedComponent } from './record-change-salesperson-updated.component';
import { CrmActivityRecordChangeOpportunityStatusChangeComponent } from './record-change-opportunity-status-change.component';
import { CrmFieldService, StandardIds } from '../../../../../../shared-services';

@Component({
  selector: 'crm-activity-record-change',
  templateUrl: './record-change.component.html',
  imports: [
    CommonModule,
    CrmActivityRecordChangeBaseComponent,
    CrmActivityRecordChangeSalespersonUpdatedComponent,
    CrmActivityRecordChangeOpportunityStatusChangeComponent,
  ],
})
export class CrmActivityRecordChangeComponent {
  activity = input<ActivityInterface>({});
  showPrimaryAssociation = input<boolean>(false);

  private readonly recordChangeTypeMapping = new Map<string, string[]>([
    ['salesperson-updated', [StandardIds.CompanyPrimarySalespersonID]],
    [
      'opportunity-status-change',
      [
        StandardIds.OpportunityStatus,
        StandardIds.OpportunityClosedLostReason,
        StandardIds.OpportunityClosedLostReasonDescription,
      ],
    ],
  ]);

  protected readonly recordChangeType = computed(() => {
    const activity = this.activity();

    const fieldIdsList = this.fieldService.getFieldValueFromCrmObject(activity, StandardIds.RecordChangeFieldIDsList);
    const changedFields = fieldIdsList?.stringValues?.values || [];

    // Check each record change type to see if any of its fields are in the changed fields
    for (const [recordChangeType, fieldsToCheck] of this.recordChangeTypeMapping) {
      if (fieldsToCheck.some((fieldId) => changedFields.includes(fieldId))) {
        return recordChangeType;
      }
    }

    return 'default';
  });

  constructor(private readonly fieldService: CrmFieldService) {}
}
